import { render, staticRenderFns } from "./ResourceCountUsage.vue?vue&type=template&id=4a92819d&scoped=true&"
import script from "./ResourceCountUsage.vue?vue&type=script&lang=js&"
export * from "./ResourceCountUsage.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCountUsage.vue?vue&type=style&index=0&id=4a92819d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a92819d",
  null
  
)

export default component.exports